import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { translation } from '../../i18n';
import * as i0 from "@angular/core";
export class WarningMessageDialogComponent {
    constructor(text) {
        this.text = text;
        this.translation = translation;
    }
}
WarningMessageDialogComponent.ɵfac = function WarningMessageDialogComponent_Factory(t) { return new (t || WarningMessageDialogComponent)(i0.ɵɵdirectiveInject(MAT_DIALOG_DATA)); };
WarningMessageDialogComponent.ɵcmp = i0.ɵɵdefineComponent({ type: WarningMessageDialogComponent, selectors: [["hw-warning-message-dialog"]], decls: 1, vars: 1, template: function WarningMessageDialogComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtext(0);
    } if (rf & 2) {
        i0.ɵɵtextInterpolate(ctx.text);
    } }, encapsulation: 2 });
//# sourceMappingURL=warning-message-dialog.component.js.map